controllers.controller('ManageAccountsController', [
    '$scope', '$rootScope', '$state', '$ionicPopover', '$ionicLoading', '$ionicHistory',
    'LocaleService', 'UserService', 'constants', 'PnlMarginService', 'LoginService', 'LocalStorage',
    'Utils', 'API', 'UserControl', 'ErrorService', 'Storage',
    function ($scope, $rootScope, $state, $ionicPopover, $ionicLoading, $ionicHistory,
              LocaleService, UserService, Const, PnlMarginService, LoginService, LocalStorage,
              Utils, API, UserControl, ErrorService, Storage) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.user = UserService.get();
        $scope.pnl = PnlMarginService;
        $scope.constants = Const;
        $scope.showCredit = Storage.get('allowCredit');

        $ionicPopover.fromTemplateUrl('templates/manageaccount-menu.html', {
            scope: $scope
        }).then(function (popover) {
            $scope.popover = popover;
        });

        $scope.openPopover = function ($event) {
            $scope.popover.show($event);
        };

        $scope.navigate = function (state, params) {
            $scope.popover.remove();
            $state.go(state, params);
        };

        if ($scope.user.tradingAccounts.length > 0) getAccounts();

        function getAccounts() {
            if ($scope.user) {
                $scope.realAccounts = _.filter($scope.user.tradingAccounts, {live: true});
                $scope.demoAccounts = _.filter($scope.user.tradingAccounts, {live: false});

                if (!$scope.user.activeTradingAccount) return;

                _.remove($scope.realAccounts, {
                    login: $scope.user.activeTradingAccount.login,
                    live: $scope.user.activeTradingAccount.live
                });

                _.remove($scope.demoAccounts, {
                    login: $scope.user.activeTradingAccount.login,
                    live: $scope.user.activeTradingAccount.live
                });
            }
        }


        $scope.modal = {
            actionText: LocaleService.translation.try_again,
            state: false
        };

        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'ManageAccountsController',
                    type: Const.error.type.VALIDATION,
                    code: data.code || 'switchAccountFailed',
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

        function switchAccount(login, live) {
            var request = {
                login: login,
                live: Utils.fromBoolean(live)
            };

            return API.mt4SwitchAccount(request)
                .then(checkResponse)
                .then(function () {
                    $scope.user.switchAccount(login, live);
                    $scope.user = UserService.get();
                    return LoginService
                        .mt4ClearServices()
                        .then(LoginService.mt4InitServices)
                        .then(function () {
                            $ionicLoading.hide();
                            $ionicHistory.clearHistory();
                            $state.go('root.app.assets', {cache: false});
                        })
                })
        }

        $scope.switchAccount = function (login, isLive) {

            $scope.loadingMessage = LocaleService.translation.logging_in;
            $ionicLoading.show({templateUrl: 'templates/directives/message-spinner.html', scope: $scope});
            return switchAccount(login, isLive)
                .then(function () {
                    return getAccounts();
                })
                .catch(function (error) {
                    $ionicLoading.hide();
                    $scope.modal.isProcess = false;
                    $scope.modal.isError = true;
                    $scope.modal.textTitle = LocaleService.translation.messages.mt4AuthFailed;
                    $scope.modal.back = 'root.app.manageAccounts';
                    $scope.modal.state = true;
                });
        };

        $scope.logout = function () {
            $scope.loadingMessage = LocaleService.translation.logging_out;
            $ionicLoading.show({templateUrl: 'templates/directives/message-spinner.html', scope: $scope});

            LoginService.logout()
                .then(function () {
                    $ionicLoading.hide();
                    $state.go('welcome');
                })
                .catch(function (error) {
                    $ionicLoading.hide();
                    $state.go('welcome');
                });
        };

        $scope.$on('$ionicView.beforeEnter', function () {
            var user = UserService.get();
            $scope.state = UserControl.getState();

            if (user && user.liveAccountExists) {
                return
            }

            if ($scope.state) {
                return $state.go($scope.state, {cache: false});
            }

            if ($scope.user && !$scope.user.tnc && Const['tncPopup']) {
                return $state.go('tnc', {cache: false});
            }

            if ($scope.user && !Const['skipRegistrationStateCheck']) {
                switch ($scope.user.registrationState) {
                    case Const.userState.initial:
                        return $state.go('signupPersonalProfile', {cache: false});
                    case Const.userState.personal:
                        return $state.go('signupQuestionnaire', {cache: false});
                }
            }

            return UserService.kycCheck();
        });

        $scope.$on('$destroy', function () {
            $scope.popover.remove();
        });

    }]);
